import BaseService from "./BaseService.js";

class ChannelsService extends BaseService {

  getChannels(params) {
    if (params) {
      return this.apiGet({
        url: `/api/channel`,
        params,
        isStore: true
      });
    }

    return this.apiGet({
      url: `/api/channels`,
      params,
      isStore: true
    });
  }

  getChannel(id) {
    return this.apiGet({
      url: `/api/channel/${id}`,
      isStore: true
    });
  }

  acquire(id) {
    return this.apiPost({
      url: `/api/subject/${id}/acquire`,
      isStore: true
    });
  }
}

export default new ChannelsService();
